import * as React from 'react';
import { NavLink, withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import State from '../../application/core/State';
import Role from '../../domain/Role';
import AdminToolbar from '../admin/AdminToolbar';
import UserToolbar from '../admin/UserToolbar';
import './NavBar.css';
import Logo from '../img/logo/wordmark.png';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';

interface StateProps {
    userRole: Role;
}

class NavBar extends React.PureComponent<StateProps & DispatchProps & RouteComponentProps<{}>> {
    public render(): JSX.Element {
        return (
            <div className="navbar">
                <NavLink exact={true} className="home-link" activeClassName="active-link" to="/">
                    <img src={Logo} />
                </NavLink>
                {this.props.userRole === Role.User && <UserToolbar />}
                {this.props.userRole === Role.Admin && <AdminToolbar />}
            </div>
        );
    }
}

const mapStateToProps = (state: State): StateProps => ({
    userRole: state.user.role
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(NavBar));



// WEBPACK FOOTER //
// ./src/view/navbar/NavBar.tsx